import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "mobx-react";
import store from "./store";
import { waitPlusReady } from "./tool/h5plus";

const root = ReactDOM.createRoot(document.getElementById("root"));

waitPlusReady(() => {
  root.render(
    <Provider store={store}>
      <App />
    </Provider>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
window.addEventListener("contextmenu", (e) => {
  e.preventDefault();
});
